import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=38867b0f"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"
import style0 from "./StatsCard.vue?vue&type=style&index=0&id=38867b0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports